import type { TypeWireContainer } from "@typewirets/core";
import { AppProviders } from "@/app-providers";
import { AppRouter } from "@/app-router";

interface AppProps {
  container: TypeWireContainer;
}

function App(props: AppProps) {
  const { container } = props;
  return (
    <AppProviders container={container}>
      <AppRouter />
    </AppProviders>
  );
}

export default App;
